module.exports = __webpack_public_path__ + "ed9da9a732.svg";